import { render, staticRenderFns } from "./Error404Page.vue?vue&type=template&id=2b14bade&scoped=true"
import script from "./Error404Page.vue?vue&type=script&lang=js"
export * from "./Error404Page.vue?vue&type=script&lang=js"
import style0 from "./Error404Page.vue?vue&type=style&index=0&id=2b14bade&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b14bade",
  null
  
)

export default component.exports